// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-container{display:flex;align-items:center;justify-content:center;color:#000;font-weight:bold;cursor:default}.avatar-container.empty{background-color:#d3d3d3}.avatar-container .avatar-name{white-space:nowrap}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
